import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Dropdown, Panel, PrimaryButton, Stack} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import DatePickerPL from "../../Components/DatePickerPL";
import {dbDate} from "../../Utilities/dbDate";
import validateForm from "../../Utilities/validateForm"

function AddTaskContractor(props) {
    const [user] = useContext(AuthContext);
    const [contractor, setContractor] = useState(null);
    const [contractors, setContractors] = useState([]);
    const [deadline, setDeadline] = useState(null)
    const [formErrors, setFormErrors] = useState({})

    const _submit = (e) => {
        e.preventDefault();
        let data, required;
        if (props.type === 'progress') {
            data = {contractor_id: contractor ? contractor.key : null, deadline: dbDate(deadline)};
            required = ['contractor_id', 'deadline']
        } else {
            data = {contractor_id: contractor ? contractor.key : null};
            required = ['contractor_id']
        }

        if(validateForm(data, required, setFormErrors)) {
            props.onSuccess(data);
            handleDismissPanel()
        }
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddTaskContractor'>Dodaj</PrimaryButton>
        <DefaultButton onClick={handleDismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setContractor(null);
        setDeadline(null)
        async function fetchData() {
            await fetch(`/api/contractor`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setContractors(data.map((item) => ({key: item.id, text: item.name})));
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchData();
        return () => abortController.abort();
    }, [props.add, user.token])

    const handleDismissPanel = () => {
        setFormErrors({})
        props.dismissPanel()
    }

    return (
        <Panel
            isOpen={props.add}
            onDismiss={handleDismissPanel}
            headerText={props.title}
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddTaskContractor'>
                <Dropdown
                    label="Wykonawca"
                    selectedKey={contractor ? contractor.key : undefined}
                    onChange={(e, item) => setContractor(item)}
                    placeholder="Wybierz z listy"
                    options={contractors}
                    errorMessage={formErrors['contractor_id']}
                    required
                />
                {props.type === 'progress' && (
                    <DatePickerPL
                        label="Termin wykonania"
                        placeholder="Wybierz datę..."
                        onSelectDate={(date) => {setDeadline(date)}}
                        isRequired
                        textField={{errorMessage: formErrors['deadline']}}
                    />
                )}
            </form>
        </Panel>
    )
}

export default AddTaskContractor;

AddTaskContractor.defaultProps = {
    title: 'Dodaj Wykonawcę',
}